import { storageKey } from "@/constants";
import { Store } from "./store";
import { createJSONStorage, persist } from "zustand/middleware";
import { ChannelTypeEnum } from "@packages/chat-sdk";

// 存放雀鲷账号级别的浏览器缓存数据
export interface DamselfishPersistentStoreType {
  teamId?: string;
  accountId?: string;
  channelType?: ChannelTypeEnum;
}
export const damselfishPersistentStore =
  new Store<DamselfishPersistentStoreType>(
    persist(
      () => ({
        teamId: undefined,
        accountId: undefined,
        channelType: undefined,
      }),
      {
        name: storageKey.DAMSELFISH_STORAGE,
        storage: createJSONStorage(() => localStorage),
      }
    ) as any
  );

export const damselfishPersistentStoreActions = {
  setTeamId(id?: string) {
    damselfishPersistentStore.set({
      teamId: id,
      accountId: undefined,
    });
  },
  setAccountId(id?: string) {
    damselfishPersistentStore.set({
      accountId: id,
    });
  },
  setChannelType(channelType?: ChannelTypeEnum) {
    damselfishPersistentStore.set({
      channelType,
      accountId: undefined,
    });
  },
  reset() {
    localStorage.removeItem(storageKey.DAMSELFISH_STORAGE);
  },
};
